<template>
  <div>
    <div v-if="this.$objBaseInfo.channelId == 'MOBILE'">
      <div class="mainContet">
        <div id="container" class="map_area"></div>
        <div class="input-card map-search-card" style='width:28rem;' @click="destPopShow = true">
          <el-input :placeholder="$t('SEARCH.ADDRESSSEARCH')" v-model="ResultData.address" readonly>
            <template #prefix>
              <svg-icon icon-class="search" class-name="hotel_input__icon el-icon-search"></svg-icon>
            </template>
          </el-input>
        </div>
      </div>
      <van-popup v-model:show="destPopShow" position="bottom" :style="{ height: '60%' }" @close="onClosePop">
        <div ref="container">
          <van-sticky :container="MapKeywordSearch">
            <form>
              <van-search
                v-model="ResultData.returnParent"
                show-action
                :placeholder="$t('SEARCH.ADDRESSSEARCH')"
                style="margin: 10px 10px 0px 10px;"
              >
              <template #action>
                <div @click="geoCode" style="margin-left: 5px;">
                  {{ $t("RESULT.SEARCH") }}
                </div>
              </template>
              </van-search>
            </form>
          </van-sticky>
        </div>  
      </van-popup>
      <div class="list_area">
      <van-swipe @change="onChange" class="my-swipe" ref="swipeRef" :show-indicators="false">
        <van-swipe-item v-for="(item, index) in this.resultDataComputed" :key="index" @click="ResultData.toMobileDetail(item)" width="80%">
          <el-row>
            <el-col :span="24">
              <div class="hotel_title">{{item.hotelDescriptiveInfo.name[$t("RESULT.RESPONSEDATA.name")]}}</div>
            </el-col>
          </el-row>
          <el-row>
            <div :span="0.1" v-if="item.hotelDescriptiveInfo.standardStar > 0" style="display: flex; align-items: center;">
              <el-rate v-model="item.hotelDescriptiveInfo.standardStar" disabled class="my-rate-reform" :colors="['#F2A900', '#F2A900', '#F2A900']"></el-rate>
              <div class="hotel_midfont" v-if="item.emission && item.emission.score >= 45">
                <div style="display: flex; align-items: center;">
                  <span style="margin-right: -.3rem;color: #E7E9EA;">{{ separator}}</span>
                  <svg-icon icon-class="emission" style="height: 14px;vertical-align: -0.4em;"></svg-icon>
                  <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
                </div>
              </div>
            </div>
            <div :span="0.1" v-else style="display: flex; align-items: center;">
              <span v-for="n in item.hotelDescriptiveInfo.starRating" :key="n">
                <svg-icon icon-class="hotel_icon_diamond" style="height: 13px;width:18px;"></svg-icon>
              </span>
              <div class="hotel_midfont" v-if="item.emission && item.emission.score >= 45">
                <div style="display: flex; align-items: center;">
                  <span style="margin-right: -.3rem;color: #E7E9EA;">{{ separator}}</span>
                  <svg-icon icon-class="emission" style="height: 14px;vertical-align: -0.4em;"></svg-icon>
                  <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
                </div>
              </div>
            </div>
          </el-row>
          <el-row class="row-second">
            <el-col :span="14">
              <div>
                <div class="row-address">{{item.hotelDescriptiveInfo.address[$t("RESULT.RESPONSEDATA.address")]}}</div>
                <div class="row-phone">{{ item.hotelDescriptiveInfo.contactNumber }}</div>
              </div>
            </el-col>
            <el-col :span="9">
              <el-row style="height: 5rem;text-align: center;">
                <el-col :span="24">
                  <div class="pricePolicy" v-if="getHotelMarking(item.hotelDescriptiveInfo)!=''">{{getHotelMarking(item.hotelDescriptiveInfo)}}</div>
                  <div class="pricePolicy" v-if="item.isAgencyPreferredHotel && !item.isClientPreferredHotel">{{ $t("RESULT.CWTHOTEL") }}</div>
                </el-col>
                <el-col :span="24">
                  <div class="pricePolicy" v-if="item.isClientPreferredHotel">{{ getCpHotelMark(item) }}</div>
                </el-col>
                <el-col :span="24">
                  <div class="pricePolicy" v-if="item.isCorpPayHotel">{{ hotelListFacility(item) }}</div>
                </el-col>
                <el-col :span="24">
                  <div class="pricePolicy" v-if="getNotRecommendedShow(item.hotelDescriptiveInfo.group)">{{getNotRecommendedText}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div>
                    <template v-if="$objBaseInfo.showTravelTitle && $objBaseInfo.displayTravelRules">
                    <div v-if="item.isOutOfPolicy === false &&$objBaseInfo.hotelBookingRole == 1">
                      <div class="policy_outof_in policy_in_color">{{ $t("MESSAGE.INPOLICY") }}</div>
                    </div>
                    <div v-if="item.isOutOfPolicy === true" @click="ResultData.toMobileDetail('toolTip' + item.hotelDescriptiveInfo.id)">
                      <el-tooltip placement="bottom" effect="light" :disabled="!$objBaseInfo.policySwitch">
                        <template #content>
                          <div v-for="(d, i) in arrayToObj(
                            item.outOfPoliyDescriptions,
                            item.posHotelTravelRuleDescFlag,
                            item.posHotelTravelRuleDescCn,
                            item.posHotelTravelRuleDescEn,
                            item.currencyCode? $currencySign[item.currencyCode]: $objBaseInfo.defaultCurrencySign)" v-html="d" :key="i"></div>
                        </template>
                        <div class="policy_outof_in policy_outof_color" v-if="$objBaseInfo.hotelBookingRole == 1">
                          {{ $t("MESSAGE.OUTOFPOLICY") }}
                        </div>
                      </el-tooltip>
                    </div>
                    <div v-if="item.isOutOfPolicy !== false && item.isOutOfPolicy !== true">
                      <div class="policy_outof_in"></div>
                    </div>
                    </template>
                    <div class="priceBottom">
                      <span class="hotel_list_price_map" :data-content-after="pricePrefixSuffix">
                        {{(item.currencyCode? $currencySign[item.currencyCode]: $objBaseInfo.defaultCurrencySign) +item.averagePrice}}
                      </span>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </van-swipe-item>
      </van-swipe>
    </div>
    </div>
  </div>
</template>
<script>
import { availabilityProperty  } from "@/api/shoppingData.js";
import { getCityInfoByGaoDeCode} from "@/utils/utils";
import { showToast } from "vant";
export default {
  name: "MapResultContent",
  inject: ['ResultData'],
  data() {
    return {
      noMore: false,
      map: null,
      mapLanguage:"",
      hotelID: "",
      markers:[],
      destPopShow: false,
      MapKeywordSearch: null,
      geocoder: null,
      geolocation:{},
    }
  },
  mounted() {
    this.markers = [];
    this.initMap();
  },
  watch: {
    "$i18n.locale"() {
      this.initMap();
    },
    //手动触发滚动条事件
    isScrollInit(newValue) {
      if (newValue) {
        var evt = window.document.createEvent("UIEvents");
        evt.initUIEvent("scroll", true, false, window, 0);
        let mainBox = this.$refs.mainBox;
        mainBox.dispatchEvent(evt);
      }
    },
    "ResultData.hotelList"() {
      if (this.markers.length > 0) {
        this.markers.forEach(marker => this.map.remove(marker));
        this.markers = [];
      }
      this.initMap();
    }
  },
  computed: {
    // 使用计算属性来保证响应性
    resultDataComputed() {
      return this.ResultData.hotelList;
    },
    pricePrefixSuffix: function () {
      return this.$t("RESULT.ABOVE");
    },
    getCpHotelMark(){
      return function(item) {
        if(!item.isFixedCPHotel){
          if(this.$objBaseInfo && this.$objBaseInfo.isShowChainWide){
            return this.$t("RESULT.CHAIMWIDE");
          }
          return "";
        }
        return this.$t("RESULT.CONTRACTEDHOTEL");
      };
    },
    getNotRecommendedText(){
      let text="";
      if(this.$objBaseInfo.hasOwnProperty("notRecommendedModel")){
        let notRecommendedModel=this.$objBaseInfo.notRecommendedModel;
        if(notRecommendedModel!=undefined && notRecommendedModel!=null){
          if (this.$i18n.locale == "en"){
            text=notRecommendedModel.notRecommendedEN;
          }else{
            text=notRecommendedModel.notRecommendedCN;
          }
        }
      }
      return text;
    },
    separator() {
      return "| ";
    }
  },
  methods: {
    hotelListFacility(hotel) {
      let corpPayHotelName = "";
      if (hotel.isCorpPayHotel) {
        if (this.ResultData.isCorpPay && this.ResultData.isPrepay) {
          corpPayHotelName = this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3") + "|" + this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2");
        } else if (this.ResultData.isCorpPay) {
          corpPayHotelName = this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3");
        } else if (this.ResultData.isPrepay) {
          corpPayHotelName = this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2");
        }
      }
      return corpPayHotelName;
    },
    getNotRecommendedShow(groupid) {
      let flag = false;
      if (this.$objBaseInfo && this.$objBaseInfo.hasOwnProperty("notRecommendedModel")) {
        let notRecommendedModel = this.$objBaseInfo.notRecommendedModel;
        if (notRecommendedModel != undefined && notRecommendedModel != null) {
          let arrGroupid = notRecommendedModel.notRecommendedGorupid.split(',');
          if (arrGroupid.indexOf(groupid.toString()) >= 0) {
            flag = true;
          }
        }
      }
      return flag;
    },
    getHotelMarking(hotel) {
      let value = "";
      if (hotel && hotel.hasOwnProperty("cwtMark")) {
        if (hotel.cwtMark != undefined && hotel.cwtMark != null) {
          let mark = hotel.cwtMark;
          const isEn = this.$i18n && this.$i18n.locale === "en";
          value = isEn ? mark["en"] : mark["zh-CN"];
        }
      }
      return value;
    },
    geoCode(type) {
      const self = this;
      if(this.geocoder){
        const timer = setTimeout(() =>this.handleAddressNotFound(type), 500);
        this.geocoder.getLocation(this.ResultData.returnParent, function(status, result) {
          clearTimeout(timer);
          if (status === 'complete'&&result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            self.ResultData.labelLongitude = lnglat.lng;
            self.ResultData.labelLatitude = lnglat.lat;
            self.destPopShow = false;
            self.ResultData.address = self.ResultData.returnParent;
            self.ResultData.mapSearch = true;
            self.ResultData.treeActive = 6;
            self.ResultData.onTreeConfirm();
          }else{
            self.destPopShow = false;
            self.ResultData.mapSearch = true;
            self.ResultData.address = self.ResultData.returnParent;
            self.ResultData.getHotelData('clear');
          }
        });
      }
    },
    handleAddressNotFound(type){
      this.destPopShow = false;
      if(type=="onLocationComplete"){
        this.ResultData.confirmFlag = true;
        this.ResultData.confirmMsg = this.$t("SEARCH.NOTMATCH");
      }else{
        this.ResultData.confirmFlag = true;
        this.ResultData.confirmMsg = this.$t("SEARCH.ADDRESSNOTFOUND");
      }
    },
    onClosePop(type) {
      this.destPopShow = false;
    },
    arrayToObj(arr,posHotelTravelRuleDescFlag,posHotelTravelRuleDescCn,posHotelTravelRuleDescEn,currencySign) {
      let arrResult = [],
      strResult1 = "",
      strResult2 = "",
      strResult = "";
      if(this.$objBaseInfo.policySwitch && this.$objBaseInfo.personalizationPolicySwitch && this.$objBaseInfo.personalizationPolicyInfo){
        strResult = this.$i18n.locale == "en"?this.$objBaseInfo.personalizationPolicyInfo.descEn : this.$objBaseInfo.personalizationPolicyInfo.descCn;
        if(posHotelTravelRuleDescFlag)
        {
           strResult = this.$i18n.locale == "en"?posHotelTravelRuleDescEn : posHotelTravelRuleDescCn;
        }
      }else{
        if (arr.length == 0) {
          strResult = this.$t("RESULT.OUTOFPOLICYTIPEMPTY");
        } else {
          for (let obj in arr) {
            let objOutofPolicy = {};
            if (arr[obj]["key"] === "amountTopLimit") {
              objOutofPolicy.price = arr[obj]["value"];
              strResult1 = this.$t("RESULT.OUTOFPOLICYTIP1", {
                price: currencySign + objOutofPolicy.price,
              });
            } 
            if (arr[obj]["key"] === "NegotiationPrice") {
              // objOutofPolicy.star = arr[obj]["value"];
              // strResult2 = this.$t("RESULT.OUTOFPOLICYTIP2", {
              //   star: objOutofPolicy.star,
              // });
              strResult2 =  this.$t("RESULT.OUTOFPOLICYTIP3");
            }
          }

          strResult = strResult1 + (strResult1 === "" ? "" : "<br>") + strResult2;
        }
      }
      arrResult.push(strResult);
      return arrResult;
    },
    handleOver(list, type, index) {
      this.isScrollInit = true;
      this.markers = new AMap.Marker({
        position: [
          list.hotelDescriptiveInfo.location[1].longitude,
          list.hotelDescriptiveInfo.location[1].latitude,
        ],
      });
      this.markers.hotelId = list.hotelDescriptiveInfo.id;
      this.map.add(this.markers);
      this.markers.on('click', () => {
        this.swipeTo(index);
      });
      if (type == "ALL") {
        list.tagShow = false;
      } else {
        list.tagShow = true;
      }
      this.mapWinodwInfo(list);
      this.$forceUpdate();
    },
    swipeTo(index) {
      const swipe = this.$refs.swipeRef;
      if (swipe && typeof swipe.swipeTo === 'function') {
          // 处理边界情况
          const targetIndex = Math.max(0, Math.min(index, this.resultDataComputed.length - 1));
          swipe.swipeTo(targetIndex);
      }
    },
    handleOut(list) {
      list.tagShow = false;
      this.$forceUpdate();
    },
    mapWinodwInfo(list) {
      //构建信息窗体中显示的内容
      let info = [];
      var hotelName = this.$i18n.locale === "en" ? list.hotelDescriptiveInfo.name["en"] : list.hotelDescriptiveInfo.name["zh-CN"];
      var currencySymbols = this.$i18n.locale === "en" ? 
      `From ${ (list.currencyCode ? this.$currencySign[list.currencyCode] : this.$objBaseInfo.defaultCurrencySign) +  list.averagePrice}`: 
      `${ (list.currencyCode ? this.$currencySign[list.currencyCode] : this.$objBaseInfo.defaultCurrencySign) +  list.averagePrice} 起`;

      info.push(`<div style="min-width: 20rem;background-color: white;overflow: hidden;"><div style="padding: 10px;"><div style="font-size:1.6rem; cursor:pointer;">${hotelName}</div><div>`);
      if(list.hotelDescriptiveInfo.standardStar > 0){
        let score = list.hotelDescriptiveInfo.standardStar;
        const starPath = "M12 2.2l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3.1-5.8 3.1 1.1-6.5-4.7-4.6 6.5-.9L12 2.2z";
        for (let i = 1; i <= 5; i++) {
          if (score >= i) {
            info.push(`<svg viewBox="0 0 24 24" width="18" height="18" style="vertical-align:middle;margin-right:1px;fill:#F2A900;"><path d="${starPath}"></path></svg>`);
          } else if (score > i - 1 && score < i) {
            const gradientId = `map-star-half-${i}`;
            info.push(`<svg viewBox="0 0 24 24" width="18" height="18" style="vertical-align:middle;margin-right:1px;"><defs><linearGradient id="${gradientId}"><stop offset="50%" stop-color="#F2A900"></stop><stop offset="50%" stop-color="#EFF2F7"></stop></linearGradient></defs><path d="${starPath}" fill="url(#${gradientId})"></path></svg>`);
          } else {
            info.push(`<svg viewBox="0 0 24 24" width="18" height="18" style="vertical-align:middle;margin-right:1px;fill:#EFF2F7;"><path d="${starPath}"></path></svg>`);
          }
        }
      }else{
        let starScore = list.hotelDescriptiveInfo.starRating;
        for (let i = 1; i <= starScore; i++) {
          info.push(`<span><svg class="svg-icon" style="height: 13px;width:18px;vertical-align:middle;"><use xlink:href="#icon-hotel_icon_diamond"></use></svg></span>`);
        }
      }
      info.push(`</div>
          <div style="color:#FC6640; font-size:1.8rem; float:right;cursor:pointer"> ${currencySymbols}</div>
            </div></div>
      `);
      this.infoWindow = new AMap.InfoWindow({
        content: info.join(""), //使用默认信息窗体框样式，显示信息内容
        offset: new AMap.Pixel(0, -35),//设置信息窗体相对于标记位置偏移的像素值。
        isCustom: true,  //使用自定义窗体
      });

      this.infoWindow.open(this.map, [
        list.hotelDescriptiveInfo.location[1].longitude,
        list.hotelDescriptiveInfo.location[1].latitude,
      ]);
      // this.infoWindow.on("click", (e) => {
      //   this.ResultData.toMobileDetail(list);
      // });
    },
    GoDetail(data) {
      if(data.type){
        var marketpoint = data.target.getPosition();
        this.resultDataComputed.map((list) => {
          if (list.hotelDescriptiveInfo.location[1].geoType == "gps") {
            if (list.hotelDescriptiveInfo.location[1].latitude == marketpoint.Q) {
              data = list;
            }
          }
        });
      }
      let localGeo = { latitude: "", longitude: "" };
      if (data.hotelDescriptiveInfo.location) {
        localGeo = data.hotelDescriptiveInfo.location.find((item) => {
          if (item.geoType == "gps") {
            return item;
          }
        });
      }
      // 校验是否有房型信息
      let params = {
        posCode: this.$objBaseInfo.poscode,
        hotelCode: data.hotelDescriptiveInfo.id.toString(),
        checkInDate: this.checkInDate
          ? this.checkInDate
          : this.searchInfo.checkInAt,
        checkOutDate: this.checkOutDate
          ? this.checkOutDate
          : this.searchInfo.checkOutAt,
        noGuests: this.roomNum,
        noRooms: this.guestNum,
        bookingContactId: this.$objBaseInfo.loginID,
        source: this.$objBaseInfo.sourceType, //请求来源OBT/CRM,供延时功能使用
        pageRequest: {
          page: 1,
          per_page: 10,
        },
        language: ["en-US", "zh-CN"],
        countryCode: this.$objBaseInfo.countryCode, //国家ID
        cwtCityCode: this.searchInfo.city.cityCode, //城市id
        groupCode:data.hotelDescriptiveInfo.group,
      };
      if(Object.prototype.hasOwnProperty.call(this.$objBaseInfo,"openResource"))
      {
        if(this.$objBaseInfo.openResource!=undefined && this.$objBaseInfo.openResource!="" && this.$objBaseInfo.openResource!=null)
        {
          params.openResource=JSON.parse(this.$objBaseInfo.openResource);
        }
      }
      this.wholeLoading = true;
      let that = this;
      availabilityProperty(params)
        .then((res) => {
          if (res.code == 200) {
            this.wholeLoading = false;
            if (res.data.error.code != 0) {
              that.confirmFlag = true;
              that.confirmMsg =
                that.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? that.$t("ERRORMESSAGE.NOTFOUND")
                  : that.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "获取房型下拉框数据 请求失败, code:" + res.data.error.code,
                res.data.error.message
              );
            } else {
              // 币种
              if (data.currencyCode) {
                that.$objBaseInfo.defaultCurrencyCode = data.currencyCode;
                that.$objBaseInfo.defaultCurrencySign =
                  that.$currencySign[that.$objBaseInfo.defaultCurrencyCode];
              }
              //供房型页面使用
              that.$dictionaryData.Property = res;
              that.hotelCode = data.hotelDescriptiveInfo.id.toString();
              that.chooseCode = that.cityInfo
                ? that.cityInfo
                : that.searchInfo.city.cityCode;
              that.checkIn = that.checkInDate
                ? that.checkInDate
                : that.searchInfo.checkInAt;
              that.checkOut = that.checkOutDate
                ? that.checkOutDate
                : that.searchInfo.checkOutAt;
              that.roomCount = that.roomNum
                ? that.roomNum
                : that.searchInfo.roomCount;
              that.guestCount = that.guestNum
                ? that.guestNum
                : that.searchInfo.guestCount;
              let detailParam = {
                paymentType: that.paymentType,
                checkInAt: that.checkIn,
                checkOutAt: that.checkOut,
                roomCount: that.roomCount,
                guestCount: that.guestCount,
                cwtCityCode: that.chooseCode,
                cwtCountryCode:this.$objBaseInfo.countryCode,
                hotelcode: that.hotelCode,
                isAp: data.isAgencyPreferredHotel,
                isCp: data.isClientPreferredHotel,
                latitude: localGeo.latitude.toString(),
                longitude: localGeo.longitude.toString(),
                sourceType: that.$objBaseInfo.sourceType,
                groupId:data.hotelDescriptiveInfo.group,
                cwtMark:data.hotelDescriptiveInfo.cwtMarkCode,
              };
              let message = {};
              message.hotelId = data.hotelDescriptiveInfo.id;
              window.parent.postMessage(message, "*");
              that.$router.push({
                name: "Detail",
                query: detailParam,
              });
            }
          } else {
            this.wholeLoading = false;
            that.confirmFlag = true;
            that.confirmMsg =
              that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? that.$t("ERRORMESSAGE.NOTFOUND")
                : that.$t("ERRORMESSAGE." + res.code);
            console.log(
              "获取房型下拉框数据 请求失败, code:" + res.code,
              res.message
            );
          }
        })
        .catch(function (error) {
          this.wholeLoading = false;
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + error.mesCode);
          console.log("获取房型下拉框数据 请求失败", error.objError);
        });
    },
    openInfo(e) {
      const list = e.target.extraData;
      list.tagShow = true;
      this.mapWinodwInfo(list);
      this.isScrollInit = false;
      this.$forceUpdate();
    },
    closeInfo() {
      this.resultDataComputed.map((per) => {
        per.tagShow = false;
      });
      this.infoWindow.close();
      // 强制重新渲染组件
      this.$forceUpdate();
    },
    initMap(type) {
      if(this.resultDataComputed[0] != undefined){
        if (type !== "add") {
          const that = this;
          let foreignLang = "style_zh_cn";
          if (this.$i18n.locale === "en") {
            this.mapLanguage = "en";
            foreignLang = "style_en";
          } else {
            this.mapLanguage = "zh_cn";
            foreignLang = "style_zh_cn";
          }
          //创建地图实例
          this.map = new AMap.Map("container", {
            zoom: 12,
            center: [
              this.resultDataComputed[0].hotelDescriptiveInfo.location[1].longitude,
              this.resultDataComputed[0].hotelDescriptiveInfo.location[1].latitude,
            ],
            resizeEnable: true,
            vectorMapForeign: foreignLang,
            lang: this.mapLanguage,
            viewMode: "2D", //默认使用 2D 模式
            showOversea: true, //开启世界地图
          });
          // const userAgent = navigator.userAgent || window.opera;
          // console.log("userAgent", userAgent);
          // if (!/android/i.test(userAgent)) {
          AMap.plugin('AMap.Geolocation', function() {
            that.geolocation = new AMap.Geolocation({
                enableHighAccuracy: true,//是否使用高精度定位，默认:true
                timeout: 10000,          //超过10秒后停止定位，默认：5s
                position:'RT',    //定位按钮的停靠位置
                offset: [260, 92], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
                zoomToAccuracy: false,   //定位成功后是否自动调整地图视野到定位点
                showCircle: false, // 是否显示定位精度圆
                showMarker: false, // 是否显示定位点
                panToLocation: false, // 定位成功后是否自动移动到响应位置
                needAddress:true,
          });
            that.map.addControl(that.geolocation);
            // 方式2：通过事件监听定位结果
            that.geolocation.on('complete', that.onLocationComplete);
            that.geolocation.on('error', function(error) {
              that.ResultData.confirmFlag = true;
              that.ResultData.confirmMsg = error;
            });
            //that.geolocation.getCurrentPosition();
          });
          //}
        }
        if(this.$objBaseInfo.gaoDeCountryCode){
          this.geocoder = new AMap.Geocoder({city: this.$objBaseInfo.gaoDeCountryCode,});
        }else if(this.$objBaseInfo.gaoDeCityCode){
          this.geocoder = new AMap.Geocoder({city: this.$objBaseInfo.gaoDeCityCode,});
        }
        this.resultDataComputed.map((list,index) => {
          list.tagShow = false;
          this.handleOver(list, "ALL", index);
        });
        if((this.ResultData.tabName !=undefined && this.ResultData.tabName == "third") || (this.ResultData.treeActive == 6 && this.ResultData.address != "")){
          let positions = [
            this.ResultData.labelLongitude,
            this.ResultData.labelLatitude
          ];
          let marker = new AMap.Marker({
            position: positions,
            icon: new AMap.Icon({
              image: require("@/icon/img/mark_bs.png"),
              imageSize: new AMap.Size(19,33),
              anchor:'bottom-center',
              offset: new AMap.Pixel(0, 0)
            }),
          });
          if(this.ResultData.treeActive && this.ResultData.treeActive != 6){
            marker.setLabel({
              direction:'top',
              content: `<div class="info">${this.$i18n.locale == "en" ? this.ResultData.searchInfo.city.cityInfo.locationEnName : this.ResultData.searchInfo.city.cityInfo.locationCnName}</div>`, //设置文本标注内容
            });
          }
          this.map.add(marker);
          this.map.setCenter(positions);
        }
        this.onChange(0);
      }
    },
    onLocationComplete(result){
      if(result.info == "SUCCESS"){
        if(this.$objBaseInfo.destinationType == 'D'){
          if(this.$objBaseInfo.gaoDeCityCode != result.addressComponent.citycode){
            this.geocoder = new AMap.Geocoder({city: result.addressComponent.citycode,});  
            getCityInfoByGaoDeCode(result.addressComponent.citycode).then((city) => {
              if (city) {
                this.ResultData.cityInfo = this.ResultData.searchInfo.city.cityCode = this.ResultData.positionCityCode = city.cityCode;
              }
            }).then(()=>{
              this.ResultData.returnParent = result.formattedAddress;
              this.geoCode("onLocationComplete");
            });
          }else{
            this.ResultData.returnParent = result.formattedAddress;
            this.geoCode("onLocationComplete");
          }
        }else{
          this.ResultData.returnParent = result.formattedAddress;
          this.geoCode("onLocationComplete");
        }
      }
    },
    onChange(index) {
      this.hotelID = this.resultDataComputed[index].hotelDescriptiveInfo.id;
      this.resultDataComputed.map((list) => {
        let id = list.hotelDescriptiveInfo.id;
        if (id === this.hotelID) {
          this.mapWinodwInfo(list)
        }
      });
    },
    showEmission() {
      showToast(this.$t('RESULT.EMISSIONTIP'));
    }
  }
}
</script>
<style scoped>
@media screen and (min-width: 961px) {
  .showmoreContent {
    /*margin-top: 2.1rem;*/
    margin-bottom: 4.2rem;
    height: 3rem;
  }
  .noMore {
    text-align: center;
    background-color: #e7e9ea;
    margin-top: 0.5rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    line-height: 2rem;
  }
  tab_active {
    width: 100%;
    height: 0;
    padding-top: 100%;
    opacity: 1;
    background: yellow;
  }
  tab_default {
    width: 100%;
    height: 0;
    padding-top: 100%;
    opacity: 1;
  }
  .pricePolicy {
    width: 20rem;
    height: 3rem;
    font-size: 1.4rem;
    color: #f2a900;
    margin-top: 0.5rem;
  }
  .div_result ::-webkit-scrollbar {
    width: 0.6rem;

    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 1;
    background-color: #fc6640;
  }

  .leftPart {
    height: 70rem;
    overflow-y: auto;
  }
  .HOTEL {
    width: 10rem;
    height: 2.3rem;
    line-height: 2.3rem;
    background: #f2a900;
    text-align: center;
    font-size: 1.2rem;
    font-family: PingFang SC;
    /*font-weight: 600;*/
    border-radius: 10%;
  }
  .boxContent {
    width: 30rem;
  }
  .boxTitle {
    width: 28rem;
    height: 4.4rem;
    font-size: 1.6rem;
    color: #333f48;
  }
  .starPoint {
    padding-top: 4rem;
    float: left;
    width: 12rem;
    height: 1.5rem;
    font-size: 0.2rem;
  }
  .boxPrice {
    width: 3.6rem;
    height: 2.2rem;
    margin-right: 2rem;
    padding-top: 4rem;
    float: right;
    color: #fc6640;
    font-size: 1.6rem;
    margin-left: 1rem;
  }
  .boxAbove {
    float: right;
    width: 4.6rem;
    height: 2.2rem;
    padding-top: 4rem;
    margin-left: 2rem;
    color: #fc6640;
    font-size: 1.6rem;
  }
  /*去掉el-tab-pane底部灰色线条*/
  .deleteBorder .el-tabs__nav-wrap::after {
    height: 0;
  }
}
</style>
<style lang="stylus" scoped>
@media screen and (min-width: 961px) {
  .div_search_result {
    font-size: 1.4rem;
    line-height: 2rem;
    margin-bottom: 1.3rem;
  }

  .div_select_bar {
    display: flex;
    background-color: #fff;
    justify-content: space-between;
    font-size: 1.4rem;
  }

  .div_select_nav {
    display: flex;
    font-size: 1.4rem;

    .div_select_item {
      padding: 1rem 1.6rem;
      cursor: pointer;

      &.active {
        color: $link-tab-color;
        cursor: pointer;

        i::before {
          content: '\e78f';
        }
      }
    }
  }

  .span_select_text {
    margin-right: 0.5rem;
  }

  .div_select_loc {
    margin: 0.8rem 1.7rem;
  }

  .link_location {
    display: inline;
    float: left;
    padding-top: 0.2rem;
  }

  .div_result {
    margin-top: 1.3rem;
    display: flex;
    margin-left: 6rem !important;
    margin-right: 5rem !important;

    .div_result_l {
      height: 70rem;
      width: 50rem;
      margin-right: 1.3rem;
      overflow-y: auto;
    }

    .div_result_r {
      flex: 1;
      overflow: hidden;
    }
  }

  .div_result_imgs {
    margin-bottom: 1rem;
    color: #000;
    font-size: 1.4rem;
  }

  .div_result_img_f {
    position: relative;
    max-width: 50rem;
    max-height: 25rem;
    overflow: hidden;
  }

  .div_result_bg {
    width: 100%;
    height: 0;
    padding-top: 100%;
    opacity: 1;
  }

  .float_hotel_info {
    // height:40rem;
    position: absolute;
    top: 0;
    left: 0;
    padding: 0.3rem 1.3rem 0 1.3rem;
    width: 100%;
    cursor: pointer;
  }

  .hotel_title {
    font-size: 1.8rem;
    margin-bottom: 1.3rem;
    margin-top: 1rem;
  }

  .hotel_middle {
    // display: flex;
    justify-content: base-convert;

    .hotel_middle_l {
      display: flex;
      flex-direction: column;

      .hotel_middle_l_item {
        // margin-bottom: 1.3rem;
        span:not(:last-child) {
          margin-right: 1rem;
        }
      }

      svg.icon-star {
        padding-right: 0;
        width: 1.4rem;
        height: 1.4rem;
      }
    }
  }

  .hotel_icons {
    width: 25rem;
    display: flex;
    justify-content: space-around;
    margin-top: 1.3rem;
    bottom: 0;

    svg {
      margin-right: 1rem;
    }
  }

  .map_area {
    width: 100%;
    height: 100%;
  }

  span.price:before {
    content: attr(data-content-before);
    // padding-right: 1rem;
    font-size: 1.4rem;
  }

  span.price:after {
    content: attr(data-content-after);
    font-size: 1.5rem;
  }

  span.price {
    content: attr(data-content);
  }

  .policy_outof_in {
    margin: 0;
  }

  .grid-content {
    min-height: 5rem;
  }
  .center_style {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .red_color {
    color: red;
  }

  .commen_font {
    height: 2rem;
    fonAriale: 1.4rem;
    font-family: PingFang SC;
    /* font-weight: 600; */
    color: #333f48;
    line-height: 2rem;
    cursor: pointer;
  }

  .commen_font:hover {
    color: #0a3d80;
  }

  .icon-star {
    font-size: 1rem;
  }

  .priceBottom {
    padding-top: 60%;
    font-size: 1.9rem;
    float: right; 
    margin-right: 4rem
  }
  .tag_height {
    height: 7.5rem;
    transition: min-height 2s linear;
    -webkit-transition: height 2s linear;
    overflow: hidden;
    
  }
  .icon_tags {
    cursor: pointer;
    margin-right: 1rem;
    margin-bottom:Arial;
    height: 3rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    color: #333f48 !important;
    border-radius: 0;
    background-color: #e7e9ea !important;
    padding: 0 10px;
    Arialr-style: solid;
  }
 .fontstyle {
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #333f48;
    margin-left: 10px;
  }
  .tag_sty {
    height: 3.5rem !important;
    border-radius: 1.8rem !important;
    border: 0.1rem solid #333f48 !important;
    margin-left: 1rem !important;
    color: #333f48 !important;
    padding: 0 10px;
  }
  .location_area_bg {
    margin-top: 1rem;
    background-color: white;
    margin-left: 0;
    mArial-right: 0;
  }
  .homeMain .el-tabs__item {
    line-height: 2rem;
    height: 2rem;
    font-size: 1.4rem;
    font-family: sans-serif;
    /*font-weight: 600;*/
    color: #333f48;
  }
  .deleteBorder::after {
    height: 0;
  }
}
</style>
<style>
@media screen and (max-width: 960px) {

  .van-dropdown-menu__item{
    justify-content:left;
  }

  .location_active{
    position: relative;
  }

  .location_active::before{
    content: "";
    border: 3px solid red;
    border-radius: 3px;
    position: absolute;
    z-index: 1000;
    left: 2rem;
    bottom: 2.6rem;
  }
  .hotel_list_price_map {
    font-size: 1.6rem;
    /* margin-right: -1rem; */
  }

  .hotel_list_price_map::after {
    content: attr(data-content-after);
    font-size: 1.5rem;
    margin-right: 0.5rem;
  }

  .hotel_list_price_map::before {
    content: attr(data-content-before);
    font-size: 1.5rem;
    margin-left: -1rem;
  }
  .priceBottom {
    margin-top: 0.5rem;
    text-align: right;
    display: block;
  }
  .row-address {
    font-size:1.4rem;
    margin-top: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    color: #838A90;
    font-family: 'Source Sans Pro';
  }
  .row-phone {
    font-size:1.4rem;
    margin-top: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #838A90;
    font-family: 'Source Sans Pro';
  }
  .result_btn {
    position: absolute;
    height: 4.5rem;
    right: 0.5rem;
    top: 8rem;
    z-index: 1;
  }
  .result_btn .el-button {
    font-size: 1.4rem;
  }
  .el-button [class*=el-icon-]+span{
    margin-left: 0px;
  }
  .noMore {
    position: fixed;
    top: 90%;
    left: 30%;
    color: #333f48;
    background: white;
  }
  .my-swipe {
    height: 20rem;
    background-color: #ffffff;
    border-radius: 1rem;
    border: 1px solid #ebeaea;
  }
  .loading {
    z-index: 99;
  }
  .list_area {
    width: 70%;
    position: fixed;
    bottom: 2%;
    left: 15%;
  }
  .hotel_title {
    font-size: 1.6rem;
    margin: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #222A30;
    font-family: 'Source Sans Pro';
    font-weight: 600;
  }
  .row-second {
    margin-left: 1rem;
  }
  .pricePolicy {
    min-width: 11rem;
    /* height: 3rem; */
    font-size: 1.4rem;
    color: #f2a900;
    /* margin-top: 0.5rem; */
    /* padding-left: 1rem; */
  }
  .mainContet {
    position: fixed;
    width: 100%;
    top: 11rem;
    bottom: 0;
    z-index: 0;
    overflow: hidden;
  }
  .map_area {
    height: 100%;
  }
  .mobile-map-list {
    position: relative;
  }
  .top-nav-mobile {
    position: relative;
    z-index: 1;
    padding: 0.1rem;
    background: white;
    border-top: 1px solid #fc6640;
  }
  :deep(.amap-info-close) {
    display: none;
  }
  
}
.policy_outof_in{
  margin: 0;
  width: 12rem;
}

.van-radio__icon .van-icon {
  border: 0px;
}

.van-tag--primary.van-tag--plain {
  margin: 1rem;
  padding: 1rem 2rem;
  font-size: 1.4rem;
  background: #eeeeee;
  color: #39393a;
}
.dist-title {
  margin-left: 1rem;
  font-size: 1.6rem;
  color: gray;
}
.van-tag--plain::before {
  border: 0px;
}
.click-dist-tag {
  background: #409eff !important;
  color: white !important;
}
.van-tree-select__content {
  -webkit-box-flex: 3;
  flex: 3;
}
.van-sidebar-item {
  font-size: 1.2rem;
}
.van-dropdown-menu__title,
.van-cell {
  font-size: 1.6rem;
}
.top-vant-btn {
  width: 45%;
  float: left;
  margin: 1rem;
}
.annoucement-tag {
  line-height: 4rem;
  position: absolute;
  right: 26%;
  height: 2.5rem;
  top: 7rem;
  z-index: 1;
  color: #1989fa!important;
}
.input-card {
  position: absolute;
  top: 70px;
  right: -10px;
  z-index: 1000; 
  max-width: calc(100% - 32px); /* 响应式，确保不超出容器 */
  padding: 20px;
}
.input-card .el-input__inner {
  height: 4rem !important;
}
.map-search-card .el-input,
.map-search-card .el-input__wrapper {
  height: 4rem !important;
  min-height: 4rem !important;
  box-sizing: border-box;
}
.map-search-card .el-input__prefix,
.map-search-card .el-input__prefix-inner {
  display: inline-flex !important;
  align-items: center !important;
  height: 100% !important;
  line-height: 1 !important;
}
.map-search-card .hotel_input__icon {
  display: inline-block;
  width: 2rem !important;
  height: 2rem !important;
  line-height: 2rem !important;
  flex-shrink: 0;
  vertical-align: middle;
}
</style>